"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var I18n = require("i18n-js");
var React = require("react");
var classNames = require("classnames");
var USD = 'USD';
var PriceDisplay = /** @class */ (function (_super) {
    tslib_1.__extends(PriceDisplay, _super);
    function PriceDisplay() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PriceDisplay.prototype.shouldShowFree = function () {
        return this.props.showFree && this.props.amountCents === 0;
    };
    PriceDisplay.prototype.shouldShowMessage = function () {
        return !!this.props.showFree || !!this.props.auction;
    };
    PriceDisplay.prototype.currencyDisplay = function () {
        if (this.shouldShowMessage())
            return null;
        if (this.props.currency !== USD) {
            return React.createElement("span", { className: "price-display__currency" }, this.props.currency);
        }
        return null;
    };
    PriceDisplay.prototype.getText = function () {
        if (this.props.auction)
            return I18n.t('commons.auction');
        if (this.shouldShowFree())
            return I18n.t('commons.free');
        return this.props.display;
    };
    PriceDisplay.prototype.render = function () {
        if (!this.props.display)
            return null;
        var classes = classNames('price-display', { 'price-display--message': this.shouldShowMessage() });
        return (React.createElement("span", { className: classes },
            this.getText(),
            this.currencyDisplay()));
    };
    return PriceDisplay;
}(React.Component));
exports.default = PriceDisplay;
//# sourceMappingURL=price_display.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/components/price_display.js
// module id = s8kc
// module chunks = 20 21